import { render, staticRenderFns } from "./GovernanceEventParts.vue?vue&type=template&id=189091a8&"
import script from "./GovernanceEventParts.vue?vue&type=script&lang=js&"
export * from "./GovernanceEventParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports